import React, { useCallback, useEffect, useState, useRef } from 'react';
import uniqid from 'uniqid';
import { IoIosWarning } from 'react-icons/io';
import { FaCheck } from 'react-icons/fa6';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import BookingFormStore from 'Stores/BookingFormStore';
import TextInput from 'Components/Forms/Elements/TextInput';
import Switch from 'Components/Forms/Elements/Switch';
import AltLoader from 'Pure/AltLoader';
import request from 'Functions/ajax/request';
import bemit from 'Functions/bemit';
import { isTrue, num, formatNum } from 'Shared/utilities';
import { action } from 'Shared/Routes';
const no_status = {};
export default function BookingDiscountCode({
  ...props
}) {
  // return null;

  const code_value = BookingFormStore.useState(s => s.discount_code);
  const data = BookingFormStore.useState(function (store) {
    const data = {
      people: store.people,
      date: store.date,
      start: store.start
    };
    data.hours_count = num(num(store.end, 0) - num(store.start, 0), 0);
    return data;
  });
  const status_messages = BookingFormStore.useState(s => s.status_messages?.discount_code || {});
  const [editable, setEditable] = useState(!window.localStorage.getItem('booking_discount_code_id'));
  const [code_error, setCodeError] = useState();
  const [show_input, setShowInput] = useState();
  const [check_id, setCheckId] = useState();
  const [loading, setLoading] = useState(false);
  const _ref_timeout = useRef();
  const _ref_req = useRef();
  useEffect(function () {
    const shown = window.localStorage.getItem('booking_use_discount_code');
    const code = window.localStorage.getItem('booking_discount_code');
    setShowInput(isTrue(shown) || code ? true : false);
    if (code) {
      BookingFormStore.update(s => {
        s.discount_code = code;
      });
      setCheckId(uniqid());
    }
  }, []);
  const handleChange = useCallback(function ({
    e,
    value,
    name
  }) {
    if (_ref_timeout.current) {
      window.clearTimeout(_ref_timeout.current);
      _ref_timeout.current = null;
    }
    if (value) {
      setLoading(true);
      _ref_timeout.current = window.setTimeout(function () {
        _ref_timeout.current = null;
        setCheckId(uniqid());
      }, 1000);
    }
    BookingFormStore.update(function (store) {
      store[name] = value;
      store.status_messages[name] = undefined;
      delete store.status_messages[name];
      ['E_CODE', 'info', 'error', 'warning'].forEach(field => store[field] = undefined);
    });
  }, []);
  const removeCode = useCallback(function (e) {
    const discounted = num(window.localStorage.getItem('booking_discount_code_discounted'));
    const amount = num(window.localStorage.getItem('amount'));
    const new_amount = num(amount + discounted);
    window.localStorage.setItem('amount', formatNum(new_amount, '0.00'));
    BookingFormStore.update(function (store) {
      store.discount_code = '';
      store.discount_code_data = {};
      store.amount = formatNum(new_amount, '0.00');
      store.grand_total = num(num(store.grand_total) + discounted);
    });
    window.localStorage.removeItem('booking_discount_code_discounted');
    window.localStorage.removeItem('booking_discount_code_id');
    window.localStorage.removeItem('booking_discount_code');
    setEditable(true);
  }, []);
  const handleSwitchToggle = useCallback(function ({
    e,
    name,
    value
  }) {
    const checked = isTrue(value);
    if (!checked) {
      removeCode();
      window.localStorage.removeItem('booking_use_discount_code');
      setEditable(true);
    } else {
      window.localStorage.setItem('booking_use_discount_code', 'true');
    }
    setShowInput(checked);
  }, [removeCode]);
  const establishment_id = props.space?._etablishment?.id;
  const space_id = props.space?.id;
  useEffect(function () {
    if (!check_id || _ref_req.current === check_id) return;
    _ref_req.current = check_id;
    setLoading(true);
    const controller = new AbortController();
    check();
    return () => {
      controller?.abort?.();
    };
    async function check() {
      try {
        var response = await request(action('CheckDiscountCode')).config({
          controller
        }).post({
          code: editable ? code_value : window.localStorage.getItem('booking_discount_code'),
          date: data.date,
          establishment_id: establishment_id,
          hours_count: data.hours_count,
          people: data.people,
          space_id: space_id,
          start: data.start
        });
      } catch (update) {
        if (controller?.signal?.aborted) return;
        setLoading(false);
        return setCodeError(update.error);
      }
      if (controller?.signal?.aborted) return;
      const {
        code,
        id,
        offered_hours,
        percent
      } = response;
      const discounted = num(response.discounted);
      setCodeError(undefined);
      setLoading(false);
      setEditable(false);
      const storage_discount = num(window.localStorage.getItem('booking_discount_code_discounted'));
      if (storage_discount > 0) {
        return BookingFormStore.update(function (store) {
          store.discount_code_data = {
            code,
            id,
            discounted,
            offered_hours,
            percent
          };
        });
      }
      window.localStorage.setItem('booking_discount_code_id', id);
      window.localStorage.setItem('booking_discount_code', code);
      window.localStorage.setItem('booking_discount_code_discounted', discounted);
      const amount = num(window.localStorage.getItem('amount'));
      let new_amount = num(amount - discounted);
      if (new_amount > 0 === false) new_amount = 0;
      window.localStorage.setItem('amount', formatNum(new_amount, '0.00'));
      BookingFormStore.update(function (store) {
        store.grand_total = num(num(store.grand_total) - discounted);
        store.amount = formatNum(new_amount, '0.00');
        store.discount_code_data = {
          code,
          id,
          discounted,
          offered_hours,
          percent
        };
      });
    }
  }, [check_id, code_value, data, establishment_id, space_id, editable]);
  if (props.space?.type !== 'a_calm_coworking_space') return null;
  const modifiers = [];
  if (code_error) modifiers.push('error');
  if (!editable) modifiers.push('has-code');
  const remove_code_btn = !editable ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "c-cart-discount-code__delete-btn",
    onClick: removeCode
  }, /*#__PURE__*/React.createElement(DeleteIcon, {
    className: "c-cart-discount-code__delete-icon"
  })) : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('c-cart-discount-code', modifiers)
  }, /*#__PURE__*/React.createElement(Switch, {
    onChange: handleSwitchToggle,
    value: isTrue(show_input),
    name: "book_with_promo_code",
    label: "Utiliser un code promo",
    className: "c-cart-discount-code__switch",
    status: no_status
  }), show_input ? /*#__PURE__*/React.createElement("div", {
    className: "c-cart-discount-code__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-cart-discount-code__input-wrapper"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    className: bemit('c-form-element', ['uppercase']) + ' u-margin-bottom-0',
    value: code_value,
    name: "discount_code",
    placeholder: "Code",
    variant: "outlined",
    status: status_messages,
    "read-only": !editable
  }), code_error ? /*#__PURE__*/React.createElement("div", {
    className: "c-cart-discount-code__error"
  }, code_error) : undefined), /*#__PURE__*/React.createElement("div", {
    className: "c-cart-discount-code__indicator"
  }, /*#__PURE__*/React.createElement(AltLoader, {
    visible: loading,
    bemit: ['bg-white', 'primary']
  }), code_error ? /*#__PURE__*/React.createElement(IoIosWarning, {
    className: "c-cart-discount-code__icon"
  }) : !editable ? /*#__PURE__*/React.createElement("div", {
    className: "c-cart-discount-code__indicator-border"
  }, /*#__PURE__*/React.createElement(FaCheck, {
    className: "c-cart-discount-code__icon"
  })) : undefined), remove_code_btn) : undefined);
}
